// A4 낱장 편집 캔버스 — 용지 치수(size + orientation).
//
// (구 "페이지 보기" 토글용 paginate/extractBreakData/usePagedCanvas는 편집 캔버스 기본 낱장 분리
//  (EditorPage의 measure()/PagedEditBody)로 대체되어 제거됨. RenderTemplate 폭 794px = A4 세로 기준.)
//
// 치수 산출은 report-composer의 pagePx(단일 소스)로 위임한다 — 엔진(RenderTemplate)·캔버스 박스·
// 페이지 분할(pageContentH)이 같은 함수를 써야 landscape swap이 어긋나지 않는다.

import { PAGE_PX_PORTRAIT, pagePx } from '@safetyhub/report-composer';

/** @deprecated 세로 기준 치수만 반환 — orientation 반영은 pageDimPx(page) 사용. */
export const PAGE_PX = PAGE_PX_PORTRAIT;

/** page(size+orientation) → px 치수(landscape면 W/H swap). 미지정=portrait. */
export const pageDimPx = pagePx;
